import { APIVersion } from 'additiv-services';
import { getSetupData } from '../../additiv-services/setup';

const setupData = getSetupData();

export const BASIC_DMS_API_URL_V21 = `${setupData.GATEWAY_API_URL}${setupData.DMS_URL_SUFFIX}/${APIVersion.V21}/documents`;
